import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import PropTypes from "prop-types";

const useStyles = makeStyles(theme => ({
    root: {
        fontWeight: 'bold',
        padding: theme.spacing(.8),
        borderRadius: theme.shape.borderRadius,
        backgroundColor: theme.palette.secondary.main
    }
}));

export default function HighlightText(props) {
    const { value } = props;
    const classes = useStyles();

    return (
        <span className={classes.root}>
            {value}
        </span>
    );
};

HighlightText.propTypes = {
    value: PropTypes.any.isRequired
};